// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  URL: '', // I think this is being used

  // Dev configs
  // aws_cognito_identity_pool_id: 'ap-south-1:c2ca58df-2491-43e0-afc0-22f1d2176666',
  // aws_cognito_region: 'ap-south-1',
  // aws_user_pools_id: 'ap-south-1_ulvQAaTiF',
  // aws_user_pools_web_client_id: '9u8tpqtc01mernbn1pl9hvaaq',
  // s3AssetsUrl: 'https://namma11-assets-public.s3.ap-south-1.amazonaws.com',
  // profileUrl: 'https://cj9h4gduj2.execute-api.ap-south-1.amazonaws.com/dev',
  // matchesUrl: 'https://eu8ctuk9ie.execute-api.ap-south-1.amazonaws.com/dev',
  // walletApi: 'https://z3a5hqwwhl.execute-api.ap-south-1.amazonaws.com/dev',
  // contestsApi: 'https://0rq65smss9.execute-api.ap-south-1.amazonaws.com/dev',
  // fantasyApi: 'https://0znrr6aehb.execute-api.ap-south-1.amazonaws.com/dev',
  // global_settings: 'https://namma11-assets-public.s3.ap-south-1.amazonaws.com',
  // pointsServer: 'http://50.203.125.25:8085',
  // appcallback: 'https://namma11mas.intuceo.com',
  // pickemUrl: 'https://noku6iqhb7.execute-api.ap-south-1.amazonaws.com/dev',
  // downloadsApiUrl: '',
  // namma11_android_apk: 'https://namma11-assets-public.s3.ap-south-1.amazonaws.com/site/assets/Namma11_android.apk',
  // teamlogoUrl :'https://namma11-assets-public.s3.ap-south-1.amazonaws.com',
  // adminApiHost: 'http://50.203.125.25:8088/api/v1',
  // razorPayKey: 'rzp_test_0MoFDloKWjGXAY',

    // // PROD configs
  // PROD configs
  aws_cognito_region: 'ap-south-1',
  aws_user_pools_id: 'ap-south-1_TjemxIYxs',
  aws_cognito_identity_pool_id: 'ap-south-1:68edf8fe-e4db-48a7-a2b3-183f80864106',
  aws_user_pools_web_client_id: '5q5v3b4maqj61glusk6g0eui7q',
  s3AssetsUrl: 'https://fantasy-qa-demo-public-assets.s3.ap-south-1.amazonaws.com',
  profileUrl: 'https://979ewpha1g.execute-api.ap-south-1.amazonaws.com/devdemo',
  matchesUrl: 'https://wbk79jvv69.execute-api.ap-south-1.amazonaws.com/devdemo',
  walletApi: 'https://qyo6p0jg8e.execute-api.ap-south-1.amazonaws.com/devdemo',
  contestsApi: 'https://ujyno1ldk8.execute-api.ap-south-1.amazonaws.com/devdemo',
  fantasyApi: 'https://aztvbs8rii.execute-api.ap-south-1.amazonaws.com/devdemo',
  pickemUrl: 'https://ip60rdi9q7.execute-api.ap-south-1.amazonaws.com/devdemo',
  downloadsApiUrl: 'https://n48ndib7k9.execute-api.ap-south-1.amazonaws.com/devdemo',
  pointsServer: 'https://3lk7c3a49l.execute-api.ap-south-1.amazonaws.com/prod',
  global_settings: 'https://fantasy-qa-demo-public-assets.s3.ap-south-1.amazonaws.com',
  appcallback: 'https://namma11mas.intuceo.com',
  namma11_android_apk: 'https://fantasy-qa-demo-public-assets.s3.ap-south-1.amazonaws.com/site/assets/Namma11_android.apk',
  teamlogoUrl:'https://fantasy-qa-demo-public-assets.s3.ap-south-1.amazonaws.com',
  adminApiHost: 'http://13.126.100.168:3000/api/v1',
  razorPayKey: 'rzp_test_0MoFDloKWjGXAY',
  shareurl: '13.126.100.168:8100'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
